import cookieHelper, { SKIP_BLOCK_EDITABLE_LAST_MONTH_KEY, SKIP_BLOCK_EDITABLE_LAST_MONTH_VALUE } from 'helpers/cookieHelper';
import { dateHelper } from 'helpers/dateHelper';
import { getTableHeightFitContent } from 'helpers/lib/reactDataGridHelpers';
import { get } from 'lodash';
import { useEffect, useState } from 'react';
import ReactDataGrid from 'react-data-grid';

const EmptyRowsView = () => {
    const message = 'Chưa có mục thu nào';
    return (
        <div style={{ textAlign: 'center', backgroundColor: '#ddd', padding: '100px' }}>
            <h3>{message}</h3>
        </div>
    );
};

function ThuVungList({ dmThuVungs, thuVungs, data, setData, monthYear }) {
    const [rows, setRows] = useState([]);
    const [columns, setColumns] = useState([]);

    const [tableHeight, setTableHeight] = useState();
    useEffect(() => {
        setTableHeight(getTableHeightFitContent());
    }, []);

    useEffect(() => {
        const rows = [];
        if (dmThuVungs) {
            dmThuVungs.forEach((dm) => {
                const matchedThuCongDoan = thuVungs.find((thuCongDoan) => thuCongDoan.code === dm.code);
                const row = {
                    dmId: dm.id,
                    code: dm.code,
                    name: dm.name,
                    amount: matchedThuCongDoan ? matchedThuCongDoan.amount : '',
                    usdAmount: matchedThuCongDoan ? matchedThuCongDoan.usd : '',
                    eurAmount: matchedThuCongDoan ? matchedThuCongDoan.eur : '',
                    audAmount: matchedThuCongDoan ? matchedThuCongDoan.aud : '',
                    notes: matchedThuCongDoan ? matchedThuCongDoan.notes : '',
                    collectDate: matchedThuCongDoan ? dateHelper.formatDate(matchedThuCongDoan.collectDate) : '',
                    dm: matchedThuCongDoan,
                };
                rows.push(row);
            });
            setRows(rows);
        }
    }, [dmThuVungs, thuVungs]);

    useEffect(() => {
        const readOnly = cookieHelper.getCookie(SKIP_BLOCK_EDITABLE_LAST_MONTH_KEY) !== SKIP_BLOCK_EDITABLE_LAST_MONTH_VALUE && dateHelper.isAfterNextMonth7thDate(monthYear);

        const columns = [
            { key: 'code', name: 'Mã số', editable: false, width: 60 },
            { key: 'name', name: 'Diễn giải', editable: false, width: 360 },
            {
                key: 'amount',
                name: 'VND (ĐV: 1000đ)',
                editable: !readOnly,
                // editable: true,
                width: 180,
            },
            { key: 'usdAmount', name: 'USD', editable: !readOnly, width: 80 },
            { key: 'eurAmount', name: 'EUR', editable: !readOnly, width: 80 },
            { key: 'audAmount', name: 'AUD', editable: !readOnly, width: 80 },
            {
                key: 'notes',
                name: 'Ghi chú',
                // editable: true,
                editable: !readOnly,
                width: 200,
            },
            { key: 'collectDate', name: 'Ngày ghi', editable: false, width: 200 },
        ].map((item) => {
            return {
                ...item,
                ...{
                    resizable: true,
                },
            };
        });
        setColumns(columns);
    }, [monthYear]);

    const onGridRowsUpdated = ({ fromRow, toRow, updated, cellKey }) => {
        const newData = new Map(data);
        const newRows = [...rows];
        for (let i = fromRow; i <= toRow; i++) {
            newRows[i] = { ...newRows[i], ...updated };
            if (get(newRows[i], 'dm.id', false) || updated[cellKey] !== '') {
                newData.set(i, newRows[i]);
            }
        }
        setRows(newRows);
        setData(newData);
    };

    const checkEditable = (props) => {
        return props.column.editable;
    };

    return (
        <div id="rdg">
            <ReactDataGrid
                columns={columns}
                rowGetter={(i) => rows[i]}
                rowsCount={rows.length}
                minHeight={tableHeight}
                enableCellSelect={true}
                onGridRowsUpdated={onGridRowsUpdated}
                emptyRowsView={EmptyRowsView}
                onCheckCellIsEditable={checkEditable}
            />
        </div>
    );
}

export default ThuVungList;
